import styled from 'styled-components';

export const FieldsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;
